import { checkUserPermissionOnPage, getSearchAllGlobalDropDownOptions } from "../../helpers/util-common";
import React, { useState, useEffect, useRef } from "react";
import lodash, { trim } from "lodash";
import { Button, InputGroup, FormControl, DropdownButton, Dropdown } from "react-bootstrap";
import AdvanceSearchPopOver from "../AdvanceSearchPopOver";
import { useDispatch, useSelector } from "react-redux";
import { PAGE_TYPE, USER_PRIVILEGE } from "../../models/navigation.models";
import CustomTooltip from "../../components/atoms/CustomTooltip";
import commonActions, { SetBallotDetailsFromData, setBallotTrackingList, SetWorkItemDetailData } from "../../common.actions";

type Option = {
    text: string;
    value: string;
    key: string;
  };
interface Props {
    onGlobalSearchSubmit: (option: string, text: string) => void;
    onAdvanceSearchSubmit: (formData: any, type: string) => {};
    committeeData: any;
    ballotDesignationData: any;
    wiListData: any;
    witnListData: any;
    standardListData: any;
    setAdvBallotSearchFormData: any;
    setAdvWorkitemSearchFormData: any;
    ballotAdvanceSearchFormData: any;
    wiAdvanceSearchFormData: any;
    ballotStatusOption: Option[];
    wiStatusOption: Option[];
    resetClicked: boolean;
    setResetClicked: any;
    currentSearchOption?: string;
    loadAdvanceSearchData: (flow: string) => void
}

const SearchBox: React.FC<Props> = (props) => {
    const [currentSearchOption, setCurrentSearchOption] = useState<string>("");
    const [currentSearchText, setCurrentSearchText] = useState<string>("");
    const [searchOptions, setSearchOptions] = useState<Array<any>>([]);
    const [showAdvanceSearchPopOver, setShowAdvanceSearchPopOver] = useState<boolean>(false);
    const ballotGlobalSearchTextRef = useRef<any>(null);
    const popoverRef = useRef<any>(null);
    const toggleRef = useRef<any>(null);
    const globalSearchText = useSelector((state: any) => state.commonReducer.globalSearchText);
    const userPermission = useSelector((state: any) => state.commonReducer.userPermission);
    const [initialOptions,setInitialOptions] = useState([]);
    const dispatch = useDispatch();
    useEffect(()=>{
            setCurrentSearchText(globalSearchText)
        },[window.location.pathname,globalSearchText])
    useEffect(()=>{
        setUpInitialSearchState();
    },[window.location.pathname,initialOptions])
    useEffect(() => {
        if (props.resetClicked) {
            ballotGlobalSearchTextRef.current.value = "";
            props.setResetClicked(false);
        }
    }, [props.resetClicked]);
    useEffect(()=>{
        if(checkUserPermissionOnPage(userPermission,PAGE_TYPE.BALLOT,USER_PRIVILEGE.VIEW)){
            const path = window.location.pathname;
            const pageName = path.split('/');
            setInitialOptions([{ id: 1, name: "Ballots", value: "ballot" }])   
            if (pageName.some(page => ["workItemDetail","dtnDetail","workitemAuditLog"].includes(page))) {
                setCurrentSearchOption("workitem");
              }else if(pageName.some(page => ["ballotDetail", "addBallotItems"].includes(page))){
                setCurrentSearchOption("ballot");
              }else{
                const currentOption = path.split('/').filter(Boolean).pop(); 
                setCurrentSearchOption(currentOption)
              }
        }else if(checkUserPermissionOnPage(userPermission,PAGE_TYPE.WORK_ITEM,USER_PRIVILEGE.VIEW)){
            setCurrentSearchOption("workitem");
            setInitialOptions([{ id: 2, name: "Work Items", value: "workitem" }]);
        }
        if(checkUserPermissionOnPage(userPermission,PAGE_TYPE.BALLOT,USER_PRIVILEGE.VIEW) && checkUserPermissionOnPage(userPermission,PAGE_TYPE.WORK_ITEM,USER_PRIVILEGE.VIEW)){
            setInitialOptions([{ id: 1, name: "Ballots", value: "ballot" },{ id: 2, name: "Work Items", value: "workitem" }])   
        }
    },[userPermission,window.location.pathname])    
    const setUpInitialSearchState = () => {
        let uniqueOptions = lodash.uniqBy(initialOptions, "value");
        setSearchOptions(uniqueOptions);

        // Initialize currentSearchOption if not found in searchOptions
        if (uniqueOptions.length > 0 && !uniqueOptions.find((opt) => opt.value === currentSearchOption)) {
            setCurrentSearchOption(uniqueOptions[0].value);
        }
        //This code will be added when authorization will be done
        /*let searchOptions = getSearchAllGlobalDropDownOptions();
            searchOptions = lodash.uniqBy(searchOptions, (result: any) => result?.value)
            if (searchOptions && searchOptions.length > 0) {
                let index = searchOptions.findIndex((option: any) => option?.value === currentSearchOption);
                if (index === -1) {
                    setCurrentSearchOption(searchOptions[0].value);
                }
            }*/
    };

    const handleSearchInputChange = (ev: any) => {
        setCurrentSearchText((ev.currentTarget.value || "").toString().trim());
    };

    const handleSearchInputKeyPress = (ev: any) => {
        if (ev.key === "Enter") {
            props.onGlobalSearchSubmit(currentSearchOption, currentSearchText);
        }
    };

    const onGlobalSearchSubmit = () => {
        SetBallotDetailsFromData(dispatch, {});
        dispatch(commonActions.setBallotDesignationData([]));
        dispatch(SetWorkItemDetailData({}));
        dispatch(setBallotTrackingList([]));
        const searchBoxValue = ballotGlobalSearchTextRef.current?.value.trim() || "";
        if (lodash.isEmpty(searchBoxValue)) {
            setCurrentSearchText("");
            props.onGlobalSearchSubmit(currentSearchOption, "");
        } else {
            props.onGlobalSearchSubmit(currentSearchOption, currentSearchText);
        }
    };

    const handleDropdownSelect = (value: any) => {
        setCurrentSearchOption(value);
        setCurrentSearchText("");
    };

    const toggleAdvanceSearchVisibility = (): void => {
        setShowAdvanceSearchPopOver(!showAdvanceSearchPopOver);
        props.loadAdvanceSearchData(currentSearchOption);
    };

    const handleClickOutside = (event: any) => {
        if (popoverRef.current && !popoverRef.current.contains(event.target) && toggleRef.current && !toggleRef.current.contains(event.target)) {
            setShowAdvanceSearchPopOver(false);
        }
    };

    useEffect(() => {
        if (showAdvanceSearchPopOver) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [showAdvanceSearchPopOver]);

    if (searchOptions && searchOptions.length > 0) {
        let index = searchOptions.findIndex((option) => option.value === currentSearchOption);

        return (
            <div className="action" data-testid="advSearchContainer">
                <div className="form-group mb-0 mr16">
                    <select
                        value={currentSearchOption}
                        name={currentSearchOption}
                        className="custom-select astm-custom-select"
                        data-testid="searchOptionDropdown"
                        onChange={(event) => handleDropdownSelect(event.target.value)}
                    >
                        {searchOptions.map((option) => (
                            <option key={option.id} value={option.value}>
                                {option.name}
                            </option>
                        ))}
                    </select>
                </div>

                <InputGroup className="search-by-design">
                    <CustomTooltip
                        title={
                            currentSearchOption === "workitem"
                                ? "Search by work item, WI tracking no., committee or standard designation"
                                : "Search by ballot designation"
                        }
                        placement="bottom"
                        className="custom-tooltip-searchbox"
                        HTMLElement={
                            <FormControl
                                ref={ballotGlobalSearchTextRef}
                                placeholder={
                                    currentSearchOption === "workitem"
                                        ? "Search by work item, WI tracking no., committee or standard designation"
                                        : "Search by ballot designation"
                                }
                                aria-label="Search"
                                aria-describedby="basic-addon"
                                value={currentSearchText}
                                onChange={handleSearchInputChange}
                                onKeyDown={handleSearchInputKeyPress}
                                data-testid="ballotSearch"
                            />
                        }
                    />
                    <i ref={toggleRef} className="astm-icon fas fa-caret-down arrow-down-btn" data-testid="AdvanceBallotSearch" onClick={toggleAdvanceSearchVisibility}></i>
                </InputGroup>

                {
                    <Button variant="warning top-search-ic" data-testid="ballotsearchbutton" onClick={onGlobalSearchSubmit}>
                        <i className="astm-icon far fa-search"></i>
                    </Button>
                }

                {showAdvanceSearchPopOver && <AdvanceSearchPopOver currentSearchOption={currentSearchOption} ballotGlobalSearchTextRef={ballotGlobalSearchTextRef} popoverRef={popoverRef} {...props} ballotAdvanceSearchFormData={props.ballotAdvanceSearchFormData} wiAdvanceSearchFormData={props.wiAdvanceSearchFormData} toggleAdvanceSearchVisibility={toggleAdvanceSearchVisibility} ballotStatusOption={props.ballotStatusOption} wiStatusOption={props.wiStatusOption}  onGlobalSearchSubmit={props.onGlobalSearchSubmit}/>}
            </div>
        );
    }

    return "";
};

export default SearchBox;
